import { GeneratorsUtility } from '../utilities/generators';
import {
  ISmartCanvasCustomStyles,
  ISmartCanvasHighlightedArea,
  ISmartCanvasOptions,
  ISmartCanvasWordOptions,
} from './interfaces/smart-canvas.interface';
import { RobotSentence, RobotWordClick } from './robots.model';

/**
 * @implements ISmartCanvasOptions
 */
export class SmartCanvasOptions implements ISmartCanvasOptions {
  public showGroupKeys: boolean;
  public enableWordSelection: boolean;
  public showImageControls: boolean;
  public splitWords: boolean;
  public enableAreaSelection: boolean;
  public showSplitWordsControl: boolean;
  public showConfidence: boolean;
  public showGroupKeysOnHover: boolean;
  public maxPagesToRead: number;
  public pageGutter: number;
  public expressClassification: boolean;
  public enableCustomFields: boolean;
  public enableAdvancedOptions: boolean;
  public showRobotSidebar: boolean;
  public showFileHeader: boolean;
  public showWordHighlights: boolean;
  public customStyles: ISmartCanvasCustomStyles;

  constructor() {
    this.showGroupKeys = false;
    this.enableWordSelection = false;
    this.showImageControls = false;
    this.splitWords = false;
    this.enableAreaSelection = true;
    this.showSplitWordsControl = false;
    this.showConfidence = true;
    this.showGroupKeysOnHover = false;
    this.pageGutter = 50;
    this.expressClassification = false;
    this.enableCustomFields = false;
    this.enableAdvancedOptions = false;
    this.maxPagesToRead = 2;
    this.showRobotSidebar = true;
    this.showFileHeader = false;
    this.showWordHighlights = true;
    this.customStyles = {
      fileSpacing: 0,
      enforceHighlight: {
        enable: true,
        opacity: 0.075,
        othersHighlights: {
          opacity: 0.01,
        },
      },
      enableProcessedWordHighlight: true,
      showHighlightThreshold: true,
      sentences: {
        fill: 'red',
        opacity: 0.075,
        strokeWidth: 1,
      },
      wordClicks: {
        fill: 'green',
        opacity: 0.075,
        strokeWidth: 1,
      },
      words: {
        processedWords: {
          fill: 'yellow',
          opacity: 0.075,
          strokeWidth: 1,
        },
        defaultWords: {
          fill: '#00D2FF',
          opacity: 0.075,
          strokeWidth: 1,
        },
      },
    };
  }
}

/**
 * @implements ISmartCanvasWordOptions
 */
export class SmartCanvasWordOptions implements ISmartCanvasWordOptions {
  public fill: string;
  public opacity: number;
  public showTooltip: boolean;
  public clickable: boolean;
  public strokeWidth: number;

  constructor(options?: ISmartCanvasWordOptions) {
    this.fill = options?.fill !== undefined ? options.fill : '#00D2FF';
    this.opacity = options?.opacity !== undefined ? options.opacity : 0.1;
    this.showTooltip = options?.showTooltip !== undefined ? options.showTooltip : false;
    this.clickable = options?.clickable !== undefined ? options.clickable : false;
    this.strokeWidth = options?.strokeWidth !== undefined ? options.strokeWidth : 1;
  }
}

/**
 * @implements ISmartCanvasHighlightedArea
 */
export class SmartCanvasHighlightedArea implements ISmartCanvasHighlightedArea {
  public boundingBoxRelative: number[];
  public pageNumber: number;
  public layoutOptions: SmartCanvasWordOptions;
  public groupName: string;
  public readonly id: number;
  public poly: any[]; //Konva.Line[];
  public thresholdPercentage: number;

  constructor(
    groupName: string,
    sentence: RobotSentence | RobotWordClick,
    layoutOptions?: ISmartCanvasWordOptions,
    thresholdPercentage?: number
  ) {
    this.boundingBoxRelative = sentence.polygon.boundingBox;
    this.layoutOptions = new SmartCanvasWordOptions({ strokeWidth: 10, ...layoutOptions });
    this.poly = [];
    this.groupName = groupName;
    if (sentence instanceof RobotWordClick) {
      this.id = GeneratorsUtility.generateHashFromString(sentence.word.key);
    } else {
      if (sentence.polygon.boundingBox) {
        this.id = GeneratorsUtility.generateHashFromBoundingBox(sentence.polygon.boundingBox);
      } else {
        this.id = GeneratorsUtility.generateHashFromString(sentence.text);
      }
    }
    this.thresholdPercentage = thresholdPercentage || 0;
  }
}
